// Module
var code = "<dls-arrow-link class=\"MxBackButton\" ng-click=\"MxBackButton.click()\"> <span class=\"MxBackButton__content\" ng-transclude>Back</span> </dls-arrow-link> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/buttons/mxBackButton/mxBackButton.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;